/**
 * Utility functions for trial ID validation to prevent API calls with undefined values
 */

export const validateTrialId = (
  trialId: any,
  context?: string
): string | null => {
  if (!trialId || trialId === "undefined" || trialId === undefined) {
    console.error(
      `Invalid trial ID detected${context ? ` in ${context}` : ""}: ${String(
        trialId
      )}`
    );
    return null;
  }

  if (typeof trialId !== "string") {
    console.warn(
      `Trial ID is not a string${
        context ? ` in ${context}` : ""
      }: ${typeof trialId}, converting...`
    );
    return String(trialId);
  }

  return trialId;
};

export const ensureValidTrialId = (trialId: any, context?: string): string => {
  const validId = validateTrialId(trialId, context);
  if (!validId) {
    throw new Error(
      `Cannot proceed without valid trial ID${context ? ` in ${context}` : ""}`
    );
  }
  return validId;
};

export const isValidTrialId = (trialId: any): boolean => {
  return validateTrialId(trialId) !== null;
};
